//# sourceMappingURL=dropdown.mjs.map
/// <reference types="./dropdown.d.mts" />
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $justin from "../../../justin/justin.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $dom from "../../../redraw_dom/redraw/dom.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $events from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $unsafe from "../../../tiamat/gleam/unsafe.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $input from "../../ds/components/input.mjs";
import * as $cy from "../../ds/cypress.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $s from "../../ds/internals/styles/dropdown.mjs";
import * as $position from "../../ds/position.mjs";
import * as $popover from "../../ds/providers/popover.mjs";
import * as $utils from "../../ds/utils.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../gleam.mjs";

const FILEPATH = "src/ds/components/dropdown.gleam";

export class Props extends $CustomType {
  constructor(on_selected, label, placeholder, disabled, selected, icon, input_class, panel_position, panel_class, show_arrow, cypress, small, stay_open, searchable, search_placeholder, sort) {
    super();
    this.on_selected = on_selected;
    this.label = label;
    this.placeholder = placeholder;
    this.disabled = disabled;
    this.selected = selected;
    this.icon = icon;
    this.input_class = input_class;
    this.panel_position = panel_position;
    this.panel_class = panel_class;
    this.show_arrow = show_arrow;
    this.cypress = cypress;
    this.small = small;
    this.stay_open = stay_open;
    this.searchable = searchable;
    this.search_placeholder = search_placeholder;
    this.sort = sort;
  }
}
export const Props$Props = (on_selected, label, placeholder, disabled, selected, icon, input_class, panel_position, panel_class, show_arrow, cypress, small, stay_open, searchable, search_placeholder, sort) =>
  new Props(on_selected,
  label,
  placeholder,
  disabled,
  selected,
  icon,
  input_class,
  panel_position,
  panel_class,
  show_arrow,
  cypress,
  small,
  stay_open,
  searchable,
  search_placeholder,
  sort);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$on_selected = (value) => value.on_selected;
export const Props$Props$0 = (value) => value.on_selected;
export const Props$Props$label = (value) => value.label;
export const Props$Props$1 = (value) => value.label;
export const Props$Props$placeholder = (value) => value.placeholder;
export const Props$Props$2 = (value) => value.placeholder;
export const Props$Props$disabled = (value) => value.disabled;
export const Props$Props$3 = (value) => value.disabled;
export const Props$Props$selected = (value) => value.selected;
export const Props$Props$4 = (value) => value.selected;
export const Props$Props$icon = (value) => value.icon;
export const Props$Props$5 = (value) => value.icon;
export const Props$Props$input_class = (value) => value.input_class;
export const Props$Props$6 = (value) => value.input_class;
export const Props$Props$panel_position = (value) => value.panel_position;
export const Props$Props$7 = (value) => value.panel_position;
export const Props$Props$panel_class = (value) => value.panel_class;
export const Props$Props$8 = (value) => value.panel_class;
export const Props$Props$show_arrow = (value) => value.show_arrow;
export const Props$Props$9 = (value) => value.show_arrow;
export const Props$Props$cypress = (value) => value.cypress;
export const Props$Props$10 = (value) => value.cypress;
export const Props$Props$small = (value) => value.small;
export const Props$Props$11 = (value) => value.small;
export const Props$Props$stay_open = (value) => value.stay_open;
export const Props$Props$12 = (value) => value.stay_open;
export const Props$Props$searchable = (value) => value.searchable;
export const Props$Props$13 = (value) => value.searchable;
export const Props$Props$search_placeholder = (value) =>
  value.search_placeholder;
export const Props$Props$14 = (value) => value.search_placeholder;
export const Props$Props$sort = (value) => value.sort;
export const Props$Props$15 = (value) => value.sort;

export class Ascending extends $CustomType {}
export const SortOrder$Ascending = () => new Ascending();
export const SortOrder$isAscending = (value) => value instanceof Ascending;

export class Descending extends $CustomType {}
export const SortOrder$Descending = () => new Descending();
export const SortOrder$isDescending = (value) => value instanceof Descending;

class NoChoice extends $CustomType {}

class Section extends $CustomType {
  constructor(title, hidden, class$) {
    super();
    this.title = title;
    this.hidden = hidden;
    this.class = class$;
  }
}

class Choice extends $CustomType {
  constructor(title, hidden, icon, value, class$, mark_selected, subtitle, content) {
    super();
    this.title = title;
    this.hidden = hidden;
    this.icon = icon;
    this.value = value;
    this.class = class$;
    this.mark_selected = mark_selected;
    this.subtitle = subtitle;
    this.content = content;
  }
}

class State extends $CustomType {
  constructor(parent_position, set_parent_position, opened, set_opened, search_input, set_search_input) {
    super();
    this.parent_position = parent_position;
    this.set_parent_position = set_parent_position;
    this.opened = opened;
    this.set_opened = set_opened;
    this.search_input = search_input;
    this.set_search_input = set_search_input;
  }
}

export function on_selected(on) {
  return new Props(
    (value) => {
      on(value);
      return undefined;
    },
    new None(),
    "Default placeholder",
    false,
    new None(),
    new None(),
    new None(),
    new $position.Left(),
    new None(),
    false,
    new None(),
    false,
    false,
    false,
    new None(),
    new None(),
  );
}

/**
 * Alternative version of `on_selected`, returning `Nil` for `None` selected values.
 */
export function on_selected_(on) {
  return new Props(
    (value) => {
      if (value instanceof Some) {
        let value$1 = value[0];
        on(value$1);
        return undefined;
      } else {
        return undefined;
      }
    },
    new None(),
    "Default placeholder",
    false,
    new None(),
    new None(),
    new None(),
    new $position.Left(),
    new None(),
    false,
    new None(),
    false,
    false,
    false,
    new None(),
    new None(),
  );
}

export function label(props, label) {
  let label$1 = new Some(label);
  return new Props(
    props.on_selected,
    label$1,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function placeholder(props, placeholder) {
  return new Props(
    props.on_selected,
    props.label,
    placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function disabled(props, disabled) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function selected(props, selected) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function icon(props, icon) {
  let icon$1 = new Some(icon);
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    icon$1,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function input_class(props, input_class) {
  let input_class$1 = new Some(input_class);
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    input_class$1,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function panel_position(props, panel_position) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function panel_class(props, panel_class) {
  let panel_class$1 = new Some(panel_class);
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    panel_class$1,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function show_arrow(props, show_arrow) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function cy(props, value) {
  let cypress = new Some(value);
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function small(props, small) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function stay_open(props, stay_open) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    stay_open,
    props.searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function searchable(props, searchable) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    searchable,
    props.search_placeholder,
    props.sort,
  );
}

export function search_placeholder(props, search_placeholder) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    new Some(search_placeholder),
    props.sort,
  );
}

export function sort(props, sort_order) {
  return new Props(
    props.on_selected,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_position,
    props.panel_class,
    props.show_arrow,
    props.cypress,
    props.small,
    props.stay_open,
    props.searchable,
    props.search_placeholder,
    new Some(sort_order),
  );
}

function search_input_row(props, state) {
  return $bool.guard(
    !props.searchable,
    $h.none(),
    () => {
      return $s.search_wrapper(
        toList([]),
        toList([
          $input.input(
            (() => {
              let _pipe = $input.value(state.search_input);
              let _pipe$1 = $input.placeholder(
                _pipe,
                $option.unwrap(props.search_placeholder, "Search..."),
              );
              let _pipe$2 = $input.on_input(_pipe$1, state.set_search_input);
              return $input.small(_pipe$2);
            })(),
          ),
        ]),
      );
    },
  );
}

function view_icon(icon) {
  let _pipe = $option.map(icon, $s.full_icon_wrapper);
  return $option.lazy_unwrap(_pipe, $h.none);
}

function get_choice_value(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let value = choice.value;
    return new Some(value);
  }
}

function get_choice(choices, value) {
  let _pipe = choices;
  let _pipe$1 = $list.find(
    _pipe,
    (c) => { return isEqual(get_choice_value(c), value); },
  );
  return $option.from_result(_pipe$1);
}

function user_selected_choice(props, choices, state, value) {
  let $ = props.stay_open;
  if ($) {
    undefined;
  } else {
    state.set_opened(false);
  }
  let $1 = get_choice(choices, new Some(value));
  if ($1 instanceof Some) {
    let choice$1 = $1[0];
    let value$1 = get_choice_value(choice$1);
    return props.on_selected(value$1);
  } else {
    return props.on_selected(new None());
  }
}

function view_choice(props, choices, state, choice) {
  if (!(choice instanceof Choice)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/components/dropdown",
      633,
      "view_choice",
      "Pattern match failed, no pattern matched the value.",
      {
        value: choice,
        start: 16223,
        end: 16253,
        pattern_start: 16234,
        pattern_end: 16244
      }
    )
  }
  let on_click = $events.on_click(
    (_) => { return user_selected_choice(props, choices, state, choice.value); },
  );
  let data = $cy.data($justin.kebab_case(choice.title) + "-choice");
  return $s.choice_wrapper(
    choice.class,
    false,
    toList([on_click, data]),
    toList([
      (() => {
        let $ = choice.content;
        if ($ instanceof Some) {
          let content = $[0];
          return content;
        } else {
          return $s.choice_icon_wrapper(
            toList([]),
            toList([view_icon(choice.icon), $h.text(choice.title)]),
          );
        }
      })(),
      (() => {
        let $ = choice.content;
        let $1 = choice.subtitle;
        if ($ instanceof Some) {
          return $h.none();
        } else if ($1 instanceof Some) {
          let subtitle = $1[0];
          return $s.subtitle_wrapper(toList([]), toList([$h.text(subtitle)]));
        } else {
          return $h.none();
        }
      })(),
      (() => {
        let $ = (isEqual(props.selected, new Some(choice.value))) || choice.mark_selected;
        if ($) {
          return $s.icon_wrapper(toList([]), toList([$icons.checkmark()]));
        } else {
          return $h.none();
        }
      })(),
    ]),
  );
}

function view_section(option) {
  let title;
  let class$;
  if (option instanceof Section) {
    title = option.title;
    class$ = option.class;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/components/dropdown",
      623,
      "view_section",
      "Pattern match failed, no pattern matched the value.",
      {
        value: option,
        start: 15988,
        end: 16035,
        pattern_start: 15999,
        pattern_end: 16026
      }
    )
  }
  return $s.section_wrapper(class$, toList([]), toList([$h.text(title)]));
}

function no_matching_choice() {
  return $s.no_choice(toList([]), toList([$h.text("No matching choice")]));
}

function sort_run(run, sort_order) {
  return $list.sort(
    run,
    (a, b) => {
      let _block;
      if (a instanceof Choice && b instanceof Choice) {
        let t1 = a.title;
        let t2 = b.title;
        _block = $string.compare(t1, t2);
      } else {
        _block = new $order.Eq();
      }
      let comparison = _block;
      if (sort_order instanceof Ascending) {
        return comparison;
      } else {
        return $order.negate(comparison);
      }
    },
  );
}

function is_choice(choice) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return false;
  } else {
    return true;
  }
}

function do_sort_choices(choices, sort_order) {
  if (choices instanceof $Empty) {
    return choices;
  } else {
    let $ = choices.head;
    if ($ instanceof Choice) {
      let $1 = $list.split_while(choices, is_choice);
      let run = $1[0];
      let rest = $1[1];
      return $list.append(
        sort_run(run, sort_order),
        do_sort_choices(rest, sort_order),
      );
    } else {
      let other = $;
      let rest = choices.tail;
      return listPrepend(other, do_sort_choices(rest, sort_order));
    }
  }
}

/**
 * Orders the rendered choices by title, ascending or descending. Section
 * headers keep their position; only the choices within each section are
 * reordered.
 * 
 * @ignore
 */
function sort_choices(choices, sort) {
  if (sort instanceof Some) {
    let sort_order = sort[0];
    return do_sort_choices(choices, sort_order);
  } else {
    return choices;
  }
}

function do_remove_empty_sections(loop$choices, loop$return) {
  while (true) {
    let choices = loop$choices;
    let return$ = loop$return;
    if (choices instanceof $Empty) {
      return return$;
    } else {
      let $ = choices.tail;
      if ($ instanceof $Empty) {
        let $1 = choices.head;
        if ($1 instanceof Section) {
          return return$;
        } else {
          let fst = $1;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      } else {
        let $1 = choices.head;
        if ($1 instanceof Section) {
          let $2 = $.head;
          if ($2 instanceof Section) {
            let fst = $2;
            let rest = $.tail;
            loop$choices = listPrepend(fst, rest);
            loop$return = return$;
          } else {
            let fst = $1;
            let rest = $;
            loop$choices = rest;
            loop$return = listPrepend(fst, return$);
          }
        } else {
          let fst = $1;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      }
    }
  }
}

function remove_empty_sections(choices) {
  return do_remove_empty_sections(choices, toList([]));
}

function does_choice_match(choice, query) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return true;
  } else {
    let title = choice.title;
    let subtitle = choice.subtitle;
    let query$1 = $string.lowercase(query);
    let title$1 = $string.lowercase(title);
    let subtitle$1 = $string.lowercase($option.unwrap(subtitle, ""));
    return $string.contains(title$1, query$1) || $string.contains(
      subtitle$1,
      query$1,
    );
  }
}

function filtered_choices(props, choices, state) {
  return $bool.guard(
    !props.searchable,
    choices,
    () => {
      return $bool.guard(
        $string.is_empty(state.search_input),
        choices,
        () => {
          let _pipe = choices;
          let _pipe$1 = $list.filter(
            _pipe,
            (_capture) => {
              return does_choice_match(_capture, state.search_input);
            },
          );
          let _pipe$2 = remove_empty_sections(_pipe$1);
          return $list.reverse(_pipe$2);
        },
      );
    },
  );
}

function portal_style(props, parent_position, max_height) {
  return $css.class$(
    toList([
      $css.position("fixed"),
      $css.min_width($length.px_(parent_position.right - parent_position.left)),
      $position.horizontal(parent_position, props.panel_position),
      $position.vertical(parent_position),
      max_height,
      (() => {
        let _pipe = props.panel_class;
        let _pipe$1 = $option.map(_pipe, $css.compose);
        return $option.lazy_unwrap(_pipe$1, $css.none);
      })(),
    ]),
  );
}

function view_dropdown_modal(props, choices, state, parent_position, max_height) {
  let style = portal_style(props, parent_position, max_height);
  let choices$1 = filtered_choices(props, choices, state);
  let choices$2 = sort_choices(choices$1, props.sort);
  let empty = props.searchable && $list.is_empty(choices$2);
  let _block;
  if (empty) {
    _block = toList([no_matching_choice()]);
  } else {
    _block = $list.filter_map(
      choices$2,
      (option) => {
        if (option instanceof NoChoice) {
          return new Error(undefined);
        } else if (option instanceof Section) {
          let $ = option.hidden;
          if ($) {
            return new Error(undefined);
          } else {
            return new Ok(view_section(option));
          }
        } else {
          let $ = option.hidden;
          if ($) {
            return new Error(undefined);
          } else {
            return new Ok(view_choice(props, choices$2, state, option));
          }
        }
      },
    );
  }
  let rest_rows = _block;
  let _pipe = $s.children_wrapper(
    style,
    toList([$utils.stop_propagation()]),
    listPrepend(search_input_row(props, state), rest_rows),
  );
  let _pipe$1 = $dom.create_portal(_pipe, "modal");
  return $result.lazy_unwrap(_pipe$1, $h.none);
}

function get_choice_title(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let title = choice.title;
    return new Some(title);
  }
}

function view_dropdown_value(props, content) {
  let _block;
  let _pipe = content;
  let _pipe$1 = $option.then$(_pipe, get_choice_title);
  _block = $option.unwrap(_pipe$1, props.placeholder);
  let value = _block;
  return $s.label_wrapper(toList([]), toList([$h.text(value)]));
}

function get_choice_icon(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let icon$1 = choice.icon;
    return icon$1;
  }
}

function view_dropdown_icon(props, content) {
  let _pipe = content;
  let _pipe$1 = $option.then$(_pipe, get_choice_icon);
  let _pipe$2 = $option.or(_pipe$1, props.icon);
  let _pipe$3 = $option.map(_pipe$2, $icons.tiny);
  return $option.lazy_unwrap(_pipe$3, $h.none);
}

function select_input_class(props, state) {
  return $bool.guard(
    props.disabled,
    $s.disabled,
    () => {
      return $bool.guard(state.opened, $s.active, () => { return $s.standard; });
    },
  );
}

function view_content(props, choices, state, max_height) {
  let content = get_choice(choices, props.selected);
  let input = select_input_class(props, state);
  let disabled$1 = $a.disabled(props.disabled);
  let type_ = $a.type_("button");
  let small$1 = $a.attribute("data-small", props.small);
  let opened = $a.attribute("data-opened", state.opened);
  return $s.full_wrapper(
    toList([]),
    toList([
      input(
        props.input_class,
        toList([disabled$1, type_, small$1, opened]),
        toList([
          $s.text_icon_wrapper(
            $option.is_some(props.selected),
            toList([]),
            toList([
              view_dropdown_icon(props, content),
              view_dropdown_value(props, content),
            ]),
          ),
          (() => {
            let $ = props.show_arrow;
            if ($) {
              return $s.arrow_wrapper(
                toList([]),
                toList([$icons.arrow_dropdown()]),
              );
            } else {
              return $h.none();
            }
          })(),
        ]),
      ),
      (() => {
        let $ = state.opened;
        let $1 = state.parent_position;
        if ($) {
          if ($1 instanceof Some) {
            let parent_position = $1[0];
            return view_dropdown_modal(
              props,
              choices,
              state,
              parent_position,
              max_height,
            );
          } else {
            return $h.none();
          }
        } else {
          return $h.none();
        }
      })(),
    ]),
  );
}

function on_toggle(props, state) {
  return $bool.lazy_guard(
    props.disabled,
    $a.none,
    () => {
      return $events.on_click(
        (event) => {
          let event$1 = $event.stop_propagation($mouse.as_event(event));
          let target = $event.target(event$1);
          let $ = $position.parent(target);
          let $1 = state.opened;
          if ($ instanceof Ok) {
            if ($1) {
              state.set_opened(false);
              return state.set_parent_position(new None());
            } else {
              let parent_position = $[0];
              state.set_parent_position(new Some(parent_position));
              return state.set_opened(true);
            }
          } else {
            return undefined;
          }
        },
      );
    },
  );
}

function use_search_input(opened) {
  return $function.tap(
    $redraw.use_state(""),
    (_use0) => {
      let set_search_input = _use0[1];
      return ((_capture) => { return $redraw.use_effect(_capture, [opened]); })(
        () => {
          return $bool.guard(
            opened,
            undefined,
            () => { return set_search_input(""); },
          );
        },
      );
    },
  );
}

function use_state() {
  let $ = $popover.use_opened();
  let opened = $[0];
  let set_opened = $[1];
  let $1 = $redraw.use_state(new None());
  let parent_position = $1[0];
  let set_parent_position = $1[1];
  let $2 = use_search_input(opened);
  let search_input = $2[0];
  let set_search_input = $2[1];
  return new State(
    parent_position,
    set_parent_position,
    opened,
    set_opened,
    search_input,
    set_search_input,
  );
}

export function dropdown() {
  return $redraw.component_(
    "Dropdown",
    (_use0) => {
      let props = _use0[0];
      let choices = _use0[1];
      let state = use_state();
      let _block;
      let _pipe = state.parent_position;
      let _pipe$1 = $option.unwrap(_pipe, $position.default_box);
      _block = $position.use_max_height(_pipe$1);
      let max_height = _block;
      let id = $redraw.use_memo(() => { return $unsafe.unique_id(); }, []);
      let id$1 = $a.id("parent_position-" + $int.to_string(id));
      let _block$1;
      let _pipe$2 = props.cypress;
      let _pipe$3 = $option.map(_pipe$2, $cy.data);
      _block$1 = $option.lazy_unwrap(_pipe$3, $a.none);
      let cy$1 = _block$1;
      return $position.div_(
        toList([id$1, on_toggle(props, state), cy$1]),
        (() => {
          let $ = props.label;
          if ($ instanceof Some) {
            let label$1 = $[0];
            return toList([
              $h.text(label$1),
              view_content(props, choices, state, max_height),
            ]);
          } else {
            return toList([view_content(props, choices, state, max_height)]);
          }
        })(),
      );
    },
  );
}

export function choice(title, value) {
  return new Choice(
    title,
    false,
    new None(),
    value,
    new $option.None(),
    false,
    new None(),
    new None(),
  );
}

export function section(title) {
  return new Section(title, false, new None());
}

export function none() {
  return new NoChoice();
}

export function no_choice() {
  return none();
}

export function with_class(choice, class$) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return new Section(choice.title, choice.hidden, new Some(class$));
  } else {
    return new Choice(
      choice.title,
      choice.hidden,
      choice.icon,
      choice.value,
      new Some(class$),
      choice.mark_selected,
      choice.subtitle,
      choice.content,
    );
  }
}

export function with_icon(choice, icon) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    return new Choice(
      choice.title,
      choice.hidden,
      new Some(icon),
      choice.value,
      choice.class,
      choice.mark_selected,
      choice.subtitle,
      choice.content,
    );
  }
}

export function as_selected(choice, selected) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    return new Choice(
      choice.title,
      choice.hidden,
      choice.icon,
      choice.value,
      choice.class,
      selected,
      choice.subtitle,
      choice.content,
    );
  }
}

export function with_subtitle(choice, subtitle) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    return new Choice(
      choice.title,
      choice.hidden,
      choice.icon,
      choice.value,
      choice.class,
      choice.mark_selected,
      new Some(subtitle),
      choice.content,
    );
  }
}

/**
 * Renders `content` in place of the default icon+title+subtitle row.
 * `title` is still required by `choice(title, value)` — it drives the
 * cypress test id and, if `searchable(True)` is on, the search match.
 */
export function with_content(choice, content) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    return new Choice(
      choice.title,
      choice.hidden,
      choice.icon,
      choice.value,
      choice.class,
      choice.mark_selected,
      choice.subtitle,
      new Some(content),
    );
  }
}

export function hidden(choice, hidden) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return new Section(choice.title, hidden, choice.class);
  } else {
    return new Choice(
      choice.title,
      hidden,
      choice.icon,
      choice.value,
      choice.class,
      choice.mark_selected,
      choice.subtitle,
      choice.content,
    );
  }
}
